import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography
} from "@mui/material";
import MuiTextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import BackButton from "../../components/BackButton";

const TextField = (props) => <MuiTextField {...props} fullWidth />;

export default function Hire() {
  const { user } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      name: user.name,
      email: user.email,
      phone: user.phone,
      city: user.city,
      project_name: "",
      details: "",
      skills: "",
      timeline: "one",
      payment_mode: "hour",
      hour: "",
      fixed: ""
    },
    onSubmit: async (values) => {
      console.log(values);
    }
  });

  useEffect(() => {
    if (formik.values.payment_mode === "hour")
      formik.setValues((values) => ({ ...values, fixed: "" }));
    else formik.setValues((values) => ({ ...values, hour: "" }));
  }, [formik.values.payment_mode]);

  return (
    <Box
      sx={{
        width: "90%",
        marginInline: "auto"
      }}
    >
      <BackButton />
      <Typography variant="h3">
        👋 Hello there! Let's get started with the basics. Now, tell us a bit
        more about your project!
      </Typography>
      <Card sx={{ p: 4 }}>
        <Typography variant="h4">
          India's Most Trusted Growth Marketing Agency!
        </Typography>
        <Typography variant="h5">
          We are India's leading agency in India with a 30+ dedicated team!
          Let’s connect to discuss your project.
        </Typography>
        <br />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField label="Name" {...formik.getFieldProps("name")} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Email" {...formik.getFieldProps("email")} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Phone" {...formik.getFieldProps("phone")} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="City" {...formik.getFieldProps("city")} />
            </Grid>
          </Grid>
          <br />
          <Divider />
          <Typography variant="h4">Tell us what you need done</Typography>
          <Typography variant="body1">
            Fill the below form correctly so that we can assign skilled experts
            within 24 hours. We will share the detailed portfolios and 24*7 chat
            support. Pay us only when you are 100% satisfied with our work.
          </Typography>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Choose a name for your Project"
                {...formik.getFieldProps("project_name")}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                multiline
                label="Tell us more about your project"
                {...formik.getFieldProps("details")}
              />
            </Grid>
            <Grid item xs={12}>
              <small>
                Enter Services that best describe your project. Our team will
                use these details to present an exact budget idea with a
                timeline.
              </small>
              <TextField
                multiline
                label="What skills are required?"
                {...formik.getFieldProps("skills")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel id="radio-buttons-group-label">
                  What is your Project Timeline?
                  <br />
                  <small>
                    Hire based on an hourly rate and pay for hours billed. Best
                    for ongoing work.
                  </small>
                </FormLabel>
                <RadioGroup
                  aria-labelledby="radio-buttons-group-label"
                  {...formik.getFieldProps("timeline")}
                >
                  <FormControlLabel
                    value="one"
                    control={<Radio />}
                    label="Within a week"
                  />
                  <FormControlLabel
                    value="one_two"
                    control={<Radio />}
                    label="One week - Two weeks"
                  />
                  <FormControlLabel
                    value="two_three"
                    control={<Radio />}
                    label="Three weeks - Four weeks"
                  />
                  <FormControlLabel
                    value="four_plus"
                    control={<Radio />}
                    label="Four weeks+ "
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel id="radio-buttons-group-label">
                  How do you want to pay?
                  <br />
                  <small>Choose any one payment mode as per your budget.</small>
                </FormLabel>
                <RadioGroup
                  aria-labelledby="radio-buttons-group-label"
                  {...formik.getFieldProps("payment_mode")}
                >
                  <FormControlLabel
                    value="hour"
                    control={<Radio />}
                    label="Pay by the hour"
                  />
                  <Box ml={2}>
                    <small style={{ marginBottom: 8 }}>
                      Hire based on an hourly rate and pay for hours billed.
                      Best for ongoing work.
                    </small>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Rate
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Rate"
                        disabled={formik.values.payment_mode !== "hour"}
                        {...formik.getFieldProps("hour")}
                      >
                        <MenuItem value="basic">
                          Basic (INR 100.00 - 400.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="moderate">
                          Moderate (INR 400.00 - 750.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="standard">
                          Standard (INR 750.00 - 1250.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="skilled">
                          Skilled (INR 1250.00 - 2,500.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="expert">
                          Expert (INR 2,500.00+ INR per hour)
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <FormControlLabel
                    value="fixed"
                    control={<Radio />}
                    label="Pay fixed price"
                  />
                  <Box ml={2}>
                    <small style={{ marginBottom: 8 }}>
                      Agree on a price and release payment when the job is done.
                      Best for one-off tasks.
                    </small>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Rate
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Rate"
                        disabled={formik.values.payment_mode !== "fixed"}
                        {...formik.getFieldProps("fixed")}
                      >
                        <MenuItem value="micro">
                          Micro Project (INR 600.00 - 1,500.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="simple">
                          Simple Project (INR 1,500.00 - 12,500.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="very_small">
                          Very small Project (INR 12,500.00 - 37,500.00 INR per
                          hour)
                        </MenuItem>
                        <MenuItem value="small">
                          Small Project (INR 37,500.00 - 75,000.00 INR per hour)
                        </MenuItem>
                        <MenuItem value="medium">
                          Medium Project (INR 75,000.00 + 150,000.00 INR per
                          hour)
                        </MenuItem>
                        <MenuItem value="large">
                          Large Project (INR 150,000.00 + 250,000.00 INR per
                          hour)
                        </MenuItem>
                        <MenuItem value="larger">
                          Larger Project (INR 250,000.00 + 500,000.00 INR per
                          hour)
                        </MenuItem>
                        <MenuItem value="very_large">
                          Very Large Project (INR 500,000.00 + 1,000,000.00 INR
                          per hour)
                        </MenuItem>
                        <MenuItem value="huge">
                          Huge Project (INR 1,000,000.00 + 4,500,000.00 INR per
                          hour)
                        </MenuItem>
                        <MenuItem value="Major">
                          Major Project (INR 2,500,000.00 + INR)
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Divider />
          <br />
          <Typography variant="body1">Customise your budget.</Typography>
          <small>You can choose the range as per your budget.</small>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Select defaultValue="inr" fullWidth>
                <MenuItem value="inr">INR</MenuItem>
                <MenuItem value="usd">USD</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={9}>
              <Select defaultValue="customise" fullWidth>
                <MenuItem value="customise">Customise budget</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <TextField type="number" label="Minimum Budget" />
            </Grid>
            <Grid item xs={12}>
              <TextField type="number" label="Maximum Budget" />
            </Grid>
          </Grid>
          <br />
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </form>
      </Card>
    </Box>
  );
}
